module.exports = __webpack_public_path__ + "static/media/ellipsis-v.396b32dd.svg";